import * as rq from '@tanstack/react-query';

import { useDependencies } from '@/api/fe-api/contexts/dependencies.context';
import type { IDocumentRepository } from '@/modules/documents/domain/repositories/document.repository';

export namespace GetAllDocuments {
  export const key = ({ siteId }: Input) => [
    'documents',
    'get-all-documents',
    siteId,
  ];

  export type Params = { refetchInterval?: number };
  export type Input = {
    siteId?: string;
  };
  export type Output = IDocumentRepository.GetAllOutput;

  export function useQuery(input: Input, { refetchInterval }: Params = {}) {
    const { repositories } = useDependencies();

    return rq.useQuery<Output>({
      refetchInterval,
      queryKey: key(input),
      queryFn: () =>
        repositories.document.getAll({
          siteIds: input.siteId ? [input.siteId] : [],
        }),
    });
  }
}
